import { render } from "./PendingPrize.vue?vue&type=template&id=50869d0b"
import script from "./PendingPrize.vue?vue&type=script&lang=js"
export * from "./PendingPrize.vue?vue&type=script&lang=js"

import "./PendingPrize.vue?vue&type=style&index=0&id=50869d0b&lang=css"
script.render = render

export default script